import { render, staticRenderFns } from "./event-detail.vue?vue&type=template&id=643b8214&scoped=true&"
import script from "./event-detail.vue?vue&type=script&lang=js&"
export * from "./event-detail.vue?vue&type=script&lang=js&"
import style0 from "./event-detail.vue?vue&type=style&index=0&id=643b8214&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b8214",
  null
  
)

export default component.exports